export const studentSummary = [
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '2c1375b4-8963-4974-bde7-3820ce9fda15',
    total_points: 1,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'c527820f-f326-4b52-92e2-883aca79c908',
      name: 'Miranda Devi',
    },
    diversity_info: {
      comments_made: 7,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 6,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {
      grade: 0,
      comment:
        'Great job Miranda,\n\nI like you incorporated a peer reviewed journal article to kickstart the conversation. Perhaps in your final project you can analyze the validity and reliability of these studies. Looking forward our class discussion!',
    },
    my_comments: [
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: 'Harriet Tubman',
        id: '04bcf50c-7900-4c2a-984a-176881dab51a',
        content:
          'The next question we have to ask ourselves is: \n1.  If companies can buy our attention, then which companies have the most influence? \n2. Are those companies being guided by any kind of ethics committee or regulatory body? \n3. If this company is widely used internationally - should there be an international body regulating it? or regional?',
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: ['896f18ec-6fd1-41a5-a6e7-aacd1af91aca'],
      },
      {
        submission_author_name: 'Chris Hadfield',
        parent_comment_author_name: null,
        id: '4ffef6f0-ef89-4f82-ba80-e9091bc77eca',
        content:
          "Dear Mr. Hadfield, my social media impression of you is that your opinions are both wise and wide ranging. So wide in fact, that they might be considered.... Out of this world ;). Space joke.  But really, it does seem like everyone is under a microscope these days. I try to make a conscious decision to remind myself that everyone is human. Not to judge the small things too much and to give people room to apologize if they miss-spoke.  \n\nA big worry of mine is that a lot of intelligent people have stopped speaking up on social media because they don't want to risk the criticism. The macro result is that people only see the really brash extremist views and are less exposed to more moderate and substantial opinions.",
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: [
          '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
          '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
        ],
      },
      {
        submission_author_name: 'Charles Darwin',
        parent_comment_author_name: 'Florence Nightingale',
        id: 'fd522b4e-8840-49fa-baec-6ffa90b9a937',
        content:
          "I appreciated your constructive feedback! Maybe we've just fixed social media right here, right now, in this thread? Boom!",
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: ['896f18ec-6fd1-41a5-a6e7-aacd1af91aca'],
      },
      {
        submission_author_name: 'Plato',
        parent_comment_author_name: 'Charles Darwin',
        id: '8eedadae-4d57-43e6-84bd-d6058c2056be',
        content:
          'What do you think about avoiding it all together? I know a lot of people who have started taking social media breaks as a way of keeping their priorities in check. It would be cool to see research done on the effects of these social media hiatuses. ',
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: ['619db365-0059-4d00-97eb-47d41b193e3a'],
      },
      {
        submission_author_name: 'Charles Darwin',
        parent_comment_author_name: null,
        id: 'ba961d05-6242-4473-8291-7e73a859a51b',
        content:
          "Bravo! And cool photo!  \n\nWe will be strongest as a community when we can use social media to support each other, not bring each other down.  I think we should make a new social media channel where you can ONLY motivate each others.  I'd be curious to see the psychological impacts of constant positive reinforcement.  Then again, maybe we would become too self-important :p. ",
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: ['d47332f7-16f5-4ff1-ae0a-d25887edc78c'],
      },
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: 'Anne Frank',
        id: '0cebd3ff-9de7-4dc0-bab1-9973c3616e13',
        content:
          "We should do a test in our class!!!  \n\nWe can find the people in class you use social media often and rarely. Split them up and make up a multi-tasking test and track who performs it better.  Then we can do a second test were people have to do a highly focused task and see who completes that better.  \n\nI wonder if the results would correlate with the info above? Let's try it! :D",
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: [],
      },
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: 'Marie Curie',
        id: '37e86469-b950-401e-b059-57eb027c2b3a',
        content:
          'First step in counter-acting social media... download an app :D! Kind of funny, But you make a good point! When you can see just how much time you are spending on social media it might trigger you to change your behaviour. ',
        user_id: 'c527820f-f326-4b52-92e2-883aca79c908',
        starred_by: [],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '0da2e802-4b8a-4bfe-b3e9-c46e28fac235',
    total_points: 3,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
      name: 'Eric Chan',
    },
    diversity_info: {
      comments_made: 6,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 6,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: null,
        id: '4cf8bb4f-7329-429a-afff-cb75305c8e4e',
        content:
          "You know, I didn't consider that social media affords us infinite access to attention seekers that are 'competing' for our attention. Coming from that point of view, it's really framed it as a question of attention economics. How much attention can we really afford to give up at a time and who deserves our attention?",
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [
          '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
          '7dcc0267-77d6-47ce-bfd8-ac7ced780c2d',
          'bf374390-2007-4a33-9cee-65b265edc5b3',
          'c527820f-f326-4b52-92e2-883aca79c908',
          '5a40c604-d093-4204-a019-1b2e10ab1af1',
          '619db365-0059-4d00-97eb-47d41b193e3a',
        ],
      },
      {
        submission_author_name: 'Euclid',
        parent_comment_author_name: null,
        id: '937365f1-45c3-423d-a18f-7f13ed0d0283',
        content:
          'Interesting take on social media and addiction. My question is... does social media cause addiction or do people with addictive tendencies seek out and abuse social media? My question is a matter of cause vs correlation. Is social media just revealing our tendencies to be addicted to the likes and retweets, or is it causing us to be more addicted to attention?',
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [],
      },
      {
        submission_author_name: 'Alexander Graham Bell',
        parent_comment_author_name: null,
        id: 'fda12043-bb66-41b8-9c6c-a8505f4a2482',
        content:
          "I like the conversation about how social media affects our ability to manage time. Some would argue that social media is not a 'waste of time' but another way to access culture developed by a variety of communities that would have otherwise been inaccessible. I don't think we should think that social media is a waste or distraction by default, but rather a useful tool that requires self awareness.",
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [],
      },
      {
        submission_author_name: 'Harriet Tubman',
        parent_comment_author_name: 'Anne Frank',
        id: 'eb93b34b-ba7c-4bb2-a45d-f5315dabddbe',
        content:
          "Anne, you bring up an interesting point. Our plastic brains are certainly affected by many kinds of stimuli. However, my response was from an evolutionary perspective. When our brain undergoes a plastic change, we don't pass those changes on to the next generation. But the fact that we are social animals indicates that social and emotional skills have provided an evolutionary advantage for hundreds of thousands of years. From that perspective, I'm simply arguing that social media (about 15 years in the making) is probably more of a reflection of the human condition rather than a driver of physical and permanent change. \n\nThat being said, you bring up a good question- To what extent does social media affect our brains at an individual level? Does it provide a negative or positive effect? I'd also consider- How do we define a negative effect?",
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [],
      },
      {
        submission_author_name: 'Amelia Earheart',
        parent_comment_author_name: null,
        id: '24dd9827-ef84-4b68-855c-ea021466a874',
        content:
          'Great post Amelia. I wonder though, would tools like Facebook have a net positive effect on social interaction. With more interaction comes more ways of inviting and getting together? Maybe these tools increase the opportunities for communication.',
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [],
      },
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: 'Marie Curie',
        id: '6cc17bfa-ca74-4d52-821d-3ecea9ff0519',
        content:
          "Another design would be to include many more students to increase the experiment's reliability and validity. For simplicity sake, we can randomly assign students from our grade to two groups, a control and an experimental group. The control group would be told to avoid social media while studying for a test, while the experimental group would be free to surf social media while studying for the same test. The time of study and test questions will remain constant for both groups. Then we can measure if social media exposure affects our ability to study or learn. Of course there are many details that we would have to hammer out, such as what kind of test should we administer? Is our grade a proper reflection of the population that we want to study? There are a few limitations to this design, but this simple experiment could be interesting to run in our classroom!",
        user_id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        starred_by: [],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '7fe6c3bd-3f13-485c-9e2c-778c26feebaa',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'b6e62156-cb3d-4f25-b920-61c98e8ecc26',
      name: 'Jane Smith',
    },
    diversity_info: {
      comments_made: 2,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 4,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Ludwig van Beethoven',
        parent_comment_author_name: 'Chris Hadfield',
        id: '20d70b44-16d1-46e3-b5e1-b79fc8276782',
        content:
          "Thanks for the cool acronym Euclid! Maybe I'll skip the whole classical thing and try out EDM. LVB sounds like a good EDM name. \n\nThere are definitely more pros and cons than I threw on the list. It would probably be a good exercise to expand on it and use it as a bit of a holistic framework.  To stop every couple weeks and think, am I getting more pos. or neg. out of social media this month? Maybe I Should take a break. ",
        user_id: 'b6e62156-cb3d-4f25-b920-61c98e8ecc26',
        starred_by: [
          '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
          'c527820f-f326-4b52-92e2-883aca79c908',
        ],
      },
      {
        submission_author_name: 'Charles Darwin',
        parent_comment_author_name: null,
        id: '61945708-106d-42d9-ae26-8774d8fb6c5d',
        content:
          "pshht.  Typical Darwin.  \n\nHaha just kidding. Great points on relationships. I think we've accepted a long time ago that our Facebook friends might not be real 'Friends'. But one thing that people don't think about is whether FB is actually diminishing our relationships with our actual living breathing awkward handshake cry and laugh together friends.",
        user_id: 'b6e62156-cb3d-4f25-b920-61c98e8ecc26',
        starred_by: [
          'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
          'c527820f-f326-4b52-92e2-883aca79c908',
        ],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: 'ee2be0a5-7008-4049-8dc1-ef09309b11dd',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'bf374390-2007-4a33-9cee-65b265edc5b3',
      name: 'Harpreet Singh',
    },
    diversity_info: {
      comments_made: 2,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 5,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Ludwig van Beethoven',
        parent_comment_author_name: null,
        id: '575c2de2-d16c-4aaa-8331-e2155bf325b0',
        content:
          'Well said! It\'s important to focus on the positive aspects, for sure. However, I think we need to be careful about saying that "Access to Information" is, in and of itself, a positive thing. There is a difference between having "access" to the information (as we would through Wikipedia) vs. the information that is deliberately presented to us. ',
        user_id: 'bf374390-2007-4a33-9cee-65b265edc5b3',
        starred_by: [
          'e382ec0a-a2f8-4787-a141-aadaea7a2bef',
          'ca04d134-00fe-4036-b3ba-8cbc531e0e74',
          '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
          '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        ],
      },
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: 'Harriet Tubman',
        id: 'f244c508-d314-43a3-8284-a524f0525d4f',
        content:
          'I think this touches on a really important point - the fact that our attention spans are being monetized. As individuals, we need to be more selective and diligent about who and what we turn our attention to. Shiny objects are sometimes gold, and sometimes landmines. We have to be more selective and careful. When we do that as a society we will change the content. Ultimately, social media advertisers are just responding to our behaviour.',
        user_id: 'bf374390-2007-4a33-9cee-65b265edc5b3',
        starred_by: ['22d00263-63e7-44c5-85e3-ef035ab1fed1'],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '746355bc-dc74-486f-aff5-7f45c4c95a43',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'e382ec0a-a2f8-4787-a141-aadaea7a2bef',
      name: 'Alice Nguyen',
    },
    diversity_info: {
      comments_made: 2,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 2,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Ludwig van Beethoven',
        parent_comment_author_name: 'Chris Hadfield',
        id: 'bdcb1f26-1079-4b72-9451-aa17755d6d65',
        content:
          'I agree that is an important distinction to make, but LVB does make that distinction by addressing the "polarization" piece in his cons list. ',
        user_id: 'e382ec0a-a2f8-4787-a141-aadaea7a2bef',
        starred_by: [
          '22d00263-63e7-44c5-85e3-ef035ab1fed1',
          'b6e62156-cb3d-4f25-b920-61c98e8ecc26',
        ],
      },
      {
        submission_author_name: 'Chris Hadfield',
        parent_comment_author_name: null,
        id: '65078717-3e62-499e-a423-c2266b4dbf18',
        content:
          "Chris, this is a very interesting post. Except that you didn't full answer the questions presented. I think next time you could talk about how these realities might affect your personal decision making. Also, could you please reference the NYT article?? Thanks :)",
        user_id: 'e382ec0a-a2f8-4787-a141-aadaea7a2bef',
        starred_by: [],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '110dfc0e-6c1d-427b-be08-4f7e34c81bff',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: '22d00263-63e7-44c5-85e3-ef035ab1fed1',
      name: 'Daniel Muller',
    },
    diversity_info: {
      comments_made: 3,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 3,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: null,
        id: '706559ca-fd88-4c3d-9273-efc73d58f5aa',
        content:
          'This is a great idea! What I would recommend is first start by downloading an application that can help you track how much time you spend on social media (so you know your baseline). Then during that month use social media and twice per day answer a question about how productive you feel. Then do the same thing the following month but with no social media and see if there is a difference! \n\nThoughts?',
        user_id: '22d00263-63e7-44c5-85e3-ef035ab1fed1',
        starred_by: [
          'c527820f-f326-4b52-92e2-883aca79c908',
          '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
        ],
      },
      {
        submission_author_name: 'Marie Curie',
        parent_comment_author_name: 'Charles Darwin',
        id: 'b4e47144-da3e-4b42-ad04-f359494d43e7',
        content:
          'Good point! I think one thing we could do would be to get people to talk about why they liked social media in the first place, on social media!',
        user_id: '22d00263-63e7-44c5-85e3-ef035ab1fed1',
        starred_by: [],
      },
      {
        submission_author_name: 'Harriet Tubman',
        parent_comment_author_name: 'Grace Hopper',
        id: '61499d49-6567-478b-a3c5-56ae5b077d48',
        content:
          'A noble idea, but are you giving the average person too much credit?',
        user_id: '22d00263-63e7-44c5-85e3-ef035ab1fed1',
        starred_by: ['d47332f7-16f5-4ff1-ae0a-d25887edc78c'],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '895d767e-0f19-4a51-bbc0-4e8c594dac21',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'ca04d134-00fe-4036-b3ba-8cbc531e0e74',
      name: 'Marcos Silva',
    },
    diversity_info: {
      comments_made: 0,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 0,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: 'd0e25491-c60d-401e-9af4-886e6e862b3d',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
      name: 'Jake Ahmed',
    },
    diversity_info: {
      comments_made: 3,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 1,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Charles Darwin',
        parent_comment_author_name: 'Florence Nightingale',
        id: 'd7a8ad91-36d1-46fd-9b8a-bd78931d75cb',
        content:
          "I think a place for open, honest and supportive dialogue is absolutely necessary. If it's all sunshine and rainbows it might be unrealistic, but any feedback or criticism must be a) constructive and b) related to the idea and not a personal attack!",
        user_id: 'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
        starred_by: [],
      },
      {
        submission_author_name: 'Marie Curie',
        parent_comment_author_name: null,
        id: '87625e7d-344e-4060-b52c-94c05eec6edb',
        content:
          "Marie, I really liked your analysis, and that was a great reference to the Slate article. I wonder if you could have expanded a little bit more on how you think we can work together to talk more openly about the benefits of social media? \n\nMaybe it's not about a world without it, but a world where it is presented and used in a balanced light?",
        user_id: 'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
        starred_by: ['22d00263-63e7-44c5-85e3-ef035ab1fed1'],
      },
      {
        submission_author_name: 'Plato',
        parent_comment_author_name: null,
        id: '1d0bcd1f-096d-4771-ade8-e8ce8ab7ff1f',
        content:
          'Agreed. It is not going away. We need to continue to make sure we are critical of it so that it evolves in a way that benefits society and reduces the risk of severe situations like bullying or online recruitment for violent/criminal organizations.',
        user_id: 'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
        starred_by: [],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: 'ad34ffd1-9769-403b-a39b-5b1c36042e1f',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: '5a40c604-d093-4204-a019-1b2e10ab1af1',
      name: 'Dankmaster',
    },
    diversity_info: {
      comments_made: 2,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 2,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Florence Nightingale',
        parent_comment_author_name: null,
        id: 'e0291abf-68e7-4a3c-97f7-5c93e1f673b2',
        content:
          "Although I agree entirely that social media is affecting our abilities to perform in depth tasks that require concentration, I fear that that we do not currently have the best methodologies and tools to truly measure how 'deep' a certain task is. If it's hard to measure, how can we properly combat it?",
        user_id: '5a40c604-d093-4204-a019-1b2e10ab1af1',
        starred_by: ['896f18ec-6fd1-41a5-a6e7-aacd1af91aca'],
      },
      {
        submission_author_name: 'Harriet Tubman',
        parent_comment_author_name: null,
        id: '4a6d01a7-1d98-4b5a-95e3-91a8611b5a37',
        content:
          'I don\'t necessarily agree with "not changing our psyche". In neuroscience, the idea of neuroplasticity explains that the human is always undergoing physical changes as they experience new things (even in adulthood).\n\nIn my opinion, it is naive to assume that social media is not having a very physical influence on how our brains re-structure themselves. I think it is up to us to understand the extent of this influence, and to find productive ways to counter-act the negative effects',
        user_id: '5a40c604-d093-4204-a019-1b2e10ab1af1',
        starred_by: ['896f18ec-6fd1-41a5-a6e7-aacd1af91aca'],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: '80e7594b-7ffd-4630-9bf0-d3766bf09abc',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: '619db365-0059-4d00-97eb-47d41b193e3a',
      name: 'Mia Tremblay',
    },
    diversity_info: {
      comments_made: 1,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 1,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [
      {
        submission_author_name: 'Ludwig van Beethoven',
        parent_comment_author_name: null,
        id: 'b06d85d1-526f-4afc-a16e-2735884ac40e',
        content:
          "I really like your point about polarization of opinions. Social media companies wouldn't like to upset the users so they will keep trying to show only opinions that you already agree with. ",
        user_id: '619db365-0059-4d00-97eb-47d41b193e3a',
        starred_by: ['896f18ec-6fd1-41a5-a6e7-aacd1af91aca'],
      },
    ],
  },
  {
    enable_annonymous: true,
    automated_feedback: [],
    submission_id: 'd112e5ff-d281-426b-8a32-c0ce0d83378a',
    total_points: 0,
    author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
    user: {
      id: 'fa4169d3-979d-4769-89eb-9746e8e1c484',
      name: 'Ivan Kuznetsov',
    },
    diversity_info: {
      comments_made: 0,
      average_comments_made: 2.727272727272727,
      total_comment_stars: 0,
      average_comment_stars_per_student: 3.272727272727273,
    },
    evaluation: {},
    my_comments: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/studentSummaries.js